import request from '@/utils/request'
import { uuid } from 'vue-uuid';

export function getBankAccountByProject(project_uid){
  return request({
    url: "/api/bankaccounts/project/" + project_uid,
    method: "get"
  });
}

export function getBankAccountBy(bankholder_id){
  return request({
    url: "/api/bankaccounts/" + bankholder_id,
    method: "get"
  });
}

export function createBankAccount(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/bankaccounts",
    method: "post",
    data: data
  });
}

export function topupBankAccount(bankholder_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/bankaccounts/" + bankholder_id + '/topup',
    method: "post",
    data: data
  });
}

export function depositBankAccount(bankholder_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/bankaccounts/" + bankholder_id + '/deposit',
    method: "post",
    data: data
  });
}

export function fakePayment(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/bankaccounts/simulatePayment",
    method: "post",
    data: data
  });
}

export function agentTransfer(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/bankaccounts/agent/transfer",
    method: "post",
    data: data
  });
}

export function updateBankAccount(bankholder_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/bankaccounts/" + bankholder_id,
    method: "put",
    data: data
  });
}

export function bankSearch(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/bankaccounts/search",
    method: "post",
    data: data
  });
}


export function deleteBankAccount(bankholder_id){
  return request({
    url: "/api/bankaccounts/" + bankholder_id,
    method: "delete",
    data: {idempotency: uuid.v1()}
  });
}

export function getBankAccountByCustomer(customer_uid ){
  return request({
    url: "/api/bankaccounts/customer/" + customer_uid ,
    method: "get"
  });
}

export function getProjectBalance(project_uid ){
  return request({
    url: "/api/bankaccounts/project/" + project_uid + "/balance" ,
    method: "get"
  });
}

export function getProjectBalances(project_uid){
  return request({
    url: "/api/bankaccounts/project/" + project_uid + "/balances" ,
    method: "get",
    // one request now waits on every ledger's vendor call (server caps each at 15s)
    timeout: 60000
  });
}

export function getCustomerBalances(customer_uid){
  return request({
    url: "/api/bankaccounts/customer/" + customer_uid + "/balances" ,
    method: "get",
    // one request now waits on every ledger's vendor call (server caps each at 15s)
    timeout: 60000
  });
}

export function getProjectBalanceByLedger(project_uid, ledger_id ){
  return request({
    url: "/api/bankaccounts/project/" + project_uid + "/balance/" + ledger_id ,
    method: "get"
  });
}

export function getCustomerBalance(customer_uid ){
  return request({
    url: "/api/bankaccounts/customer/" + customer_uid + "/balance" ,
    method: "get"
  });
}

export function getCustomerBalanceByLedger(customer_uid, ledger_id ){
  return request({
    url: "/api/bankaccounts/customer/" + customer_uid + "/balance/" + ledger_id ,
    method: "get"
  });
}

export function getCompliance(bankholder_id){
  return request({
    url: `/api/compliances/${bankholder_id}`,
    method: "get"
  });
}

export function bankPurchase(bankholder_id, data){
  return request({
    url: `/api/bankaccounts/${bankholder_id}/purchase`,
    method: 'post',
    data: data
  })
}